import { Box, Flex, Tooltip } from '@chakra-ui/react';
import { Button, SectionLabel } from '@kula-ai/components';
import { Eye } from '@kula-ai/icons/outline/Eye';
import { Trash01 } from '@kula-ai/icons/outline/Trash01';
import { PlusCircle } from '@kula-ai/icons/outline/PlusCircle';
import { KSelect } from '@/ui-library/components/molecules/KSelect';
import { SCHEDULE_AI_COPY } from '../../constants';

const COPY = SCHEDULE_AI_COPY;

export const ContextTemplateSection = ({
  selectedTemplateIds,
  setSelectedTemplateIds,
  templates,
  templateOptions,
  getAvailableOptions,
  newTemplateRowRef,
  setPreviewTemplate,
  addDisabled,
  addTooltip,
  showContextTemplateRows,
  onAddContextTemplateRow,
}) => {
  return (
    <Box mb="20px">
      <Box mb="12px">
        <SectionLabel>{COPY.contextTemplateLabel}</SectionLabel>
      </Box>
      {showContextTemplateRows && selectedTemplateIds.length > 0 && (
        <Flex flexDir="column" gap="8px" mb="10px">
          {selectedTemplateIds.map((val, idx) => {
            const templateObj = templates.find(
              (t) => t.id === val || String(t.id) === String(val)
            );
            const isNewEmptyRow =
              idx === selectedTemplateIds.length - 1 && val === '';
            return (
              <Flex
                key={idx}
                ref={isNewEmptyRow ? newTemplateRowRef : undefined}
                gap="8px"
                alignItems="center"
              >
                <Box flex="1">
                  <KSelect
                    options={getAvailableOptions(val)}
                    value={
                      templateOptions.find(
                        (opt) =>
                          opt.value === val || String(opt.value) === String(val)
                      ) || null
                    }
                    onChange={(opt) => {
                      const updated = [...selectedTemplateIds];
                      updated[idx] = opt?.value || '';
                      setSelectedTemplateIds(updated);
                    }}
                    placeholder="Select context template"
                  />
                </Box>
                <Button
                  type="button"
                  variant="quaternary"
                  size="icon-large"
                  disabled={!val}
                  onClick={() => setPreviewTemplate(templateObj)}
                  leftElement={<Eye width={18} height={18} color="#6D659D" />}
                />
                <Button
                  type="button"
                  variant="quaternary"
                  size="icon-large"
                  onClick={() =>
                    setSelectedTemplateIds(
                      selectedTemplateIds.filter((_, i) => i !== idx)
                    )
                  }
                  leftElement={
                    <Trash01 width={18} height={18} color="#6D659D" />
                  }
                />
              </Flex>
            );
          })}
        </Flex>
      )}
      <Tooltip label={addTooltip} isDisabled={!addDisabled} hasArrow>
        <Box w="fit-content">
          <Button
            type="button"
            variant="quaternary"
            size="regular"
            disabled={addDisabled}
            onClick={onAddContextTemplateRow}
            leftElement={
              <Box
                bgColor="secondary-50"
                borderRadius="full"
                display="inline-flex"
                alignItems="center"
                justifyContent="center"
              >
                <PlusCircle width={16} height={16} />
              </Box>
            }
          >
            {selectedTemplateIds.length === 0
              ? COPY.addContextTemplate
              : 'Add another template'}
          </Button>
        </Box>
      </Tooltip>
    </Box>
  );
};
